const SPLIT_TRAFFIC_TYPE = "anonymous";
const SPLIT_KEY = "1s1spa5hcm809h8e7cts6cfp6fg5s5fqn5uv";
const FOR_MERCHANTS_SPLIT = "RouteWeb_ForMerchants";
const EXPERIMENT_ROUTE_COM_BUSINESS_SHOPPERS_HOMEPAGE =
  "Experiment_Route_Com_Business_Shoppers_Homepage";
const FEATURE_FLAGS = [
  FOR_MERCHANTS_SPLIT,
  EXPERIMENT_ROUTE_COM_BUSINESS_SHOPPERS_HOMEPAGE,
];

let client;

export function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function getDeviceId() {
  const cookieUserKey = getCookieValue("userKey");
  return cookieUserKey;
}

export const loadTreatments = (userKey, setTreatments) => {
  if (client) {
    client.destroy();
  }

  const factory = splitio.SplitFactory({
    core: {
      authorizationKey: SPLIT_KEY,
      key: userKey,
      trafficType: SPLIT_TRAFFIC_TYPE,
    },
    storage: splitio.InLocalStorage(),
  });

  client = factory.client();

  const handleEvent = () => {
    const treatments = client.getTreatmentsWithConfig(FEATURE_FLAGS);
    setTreatments(treatments);
  };

  client.once(client.Event.SDK_READY, handleEvent);
  client.once(client.Event.SDK_READY_TIMED_OUT, handleEvent);
};
